<template>
  <v-row class="mb-2 mb-lg-6" v-if="loading || getCarouselBanners.length > 0">
    <v-col class="v-col-12 pa-0" :style="mobile == true ? 'min-height: 100px;': 'min-height: 350px;'">
      <v-skeleton-loader :loading="loading" :width="'100%'" :height="mobile == true ? '120': '425'">
        <Carousel ref="carousel" :settings="settings">
          <Slide v-for="banner in getCarouselBanners" :key="banner">
            <a v-if="banner" class="w-100" :href="banner.url" v-bind:target="banner.target ? '_blank' : ''">
              <v-img :src="banner.image" :alt="banner.title" eager></v-img>
            </a>
          </Slide>
          <template #addons>
            <navigation />
          </template>
        </Carousel>
      </v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'CarouselProduct',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data(){
    return {
      settings: {
        itemsToShow: 1,
        snapAlign: 'center',
        wrapAround: true,
        autoplay: 5000
      },
      mobile: false,
      loading: true
    }
  },
  computed: {
    ...mapState('main', {
      loadingBanners: 'loadingBanners'
    }),
    ...mapGetters('main', {
      getCarouselBanners: "getCarouselBanners"
    }),
  },
  watch: {
    'loadingBanners': function () {
      if(this.loadingBanners == -1)
        this.loading = false;
      else if (this.loadingBanners == 0)
        this.loading = true;
    },
    'getCarouselBanners.length': function () {
      if(this.loadingBanners == -1)
        this.loading = false;
      else if(this.loadingBanners == 1)
        this.loading = false;
      else
        this.loading = true;
    }
  },
  methods: {
    checkLayout(){
      var val = window.innerWidth;
      if (parseFloat(val) >= 1280) {
          this.mobile = false;
      } else {
          this.mobile = true;
      }
    },
  },
  mounted(){
    this.checkLayout();
    window.addEventListener("resize", this.checkLayout);
  },
  unmounted(){
    window.removeEventListener("resize", this.checkLayout);
  }
}
</script>